import Link, { LinkProps } from "next/link";

import ClearIcon from "@/components/Icons/x.svg";

const FilterChipLink = ({
  children,
  href,
}: {
  children: React.ReactNode;
  href: LinkProps["href"];
}) => (
  <Link
    href={href}
    className="flex items-center text-xs font-bold py-xs px-sm bg-green-20 border border-green-40 rounded flex-shrink-0 capitalize"
  >
    <span className="text-left truncate-lines max-w-[200px]">{children}</span>
    <ClearIcon height="12" width="12" className="ml-xs" />
  </Link>
);

export default FilterChipLink;
